import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import { Box, Typography } from '@mui/material';
import { StyledGridTab } from './styles';
import PersonalDataStep from './WizardSteps/PersonalDataStep';
import PersonalHealthStep from './WizardSteps/PersonalHealthStep';
import ShotgunDetailsStep from './WizardSteps/ShotgunDetailsStep';
import RefereeDetailsStep from './WizardSteps/RefereeDetailsStep';
import OffencesStep from './WizardSteps/OffencesStep';
import DeclarationStep from './WizardSteps/DeclarationStep';

const steps = [
  'Personal Data',
  'Health and Medical Declaration',
  'Shotgun Details',
  'Referee Details',
  'Offences',
  'Declaration',
];

const ApplicationDetailsStep = () => {
  const [selected, setSelected] = useState(0);

  const getStepContent = () => {
    switch (selected) {
      case 0:
        return <PersonalDataStep />;
      case 1:
        return <PersonalHealthStep />;
      case 2:
        return <ShotgunDetailsStep />;
      case 3:
        return <RefereeDetailsStep />;
      case 4:
        return <OffencesStep />;
      case 5:
        return <DeclarationStep />;
      default:
        return <>-</>;
    }
  };

  return (
    <>
      <Grid container gap={1}>
        {steps.map((step, index) => (
          <StyledGridTab
            item
            sx={{ flex: 1 }}
            selected={index === selected}
            onClick={() => setSelected(index)}
          >
            <Typography variant="caption">Step {index + 1}</Typography>
            <Typography variant="subtitle2">{step}</Typography>
          </StyledGridTab>
        ))}
      </Grid>

      <Box>{getStepContent()}</Box>
    </>
  );
};

export default ApplicationDetailsStep;
